import format from "date-fns/format";
import { OrderWithPrescription, Column } from "src/api/types";

export const columns: Column<OrderWithPrescription>[] = [
  {
    id: "id",
    label: "ID",
    minWidth: 30,
    orderBy: "id",
    align: "center",
    format: (order) => order.id.toString(),
    orderable: true,
  },
  {
    id: "patient_id",
    label: "Patient",
    minWidth: 120,
    align: "center",
    format: (order) => order.patient_id.toString(),
    orderable: false,
  },
  {
    id: "pharmacy",
    label: "Pharmacy",
    minWidth: 100,
    align: "center",
    format: (order) =>
      order.sent_to_external_pharmacy && order.external_pharmacy?.name != null
        ? order.external_pharmacy?.name
        : order.pharmacy.name,
    orderable: false,
  },
  {
    id: "product",
    label: "Product",
    align: "center",
    minWidth: 100,
    format: (order) => order.product.display_name,
    orderable: false,
  },
  {
    id: "billing_model",
    label: "Billing",
    align: "center",
    minWidth: 100,
    format: (order) => order.product.billing_model,
    orderable: false,
  },
  {
    id: "created_at",
    label: "Created at",
    minWidth: 100,
    align: "center",
    format: (order) =>
      format(new Date(order.created_at), `MMM d yyyy 'at' h:mm a`),
    orderable: true,
    orderBy: "created_at",
  },
  {
    id: "status",
    label: "Status",
    minWidth: 80,
    align: "center",
    format: (order) => order.status,
    orderable: false,
  },
  {
    id: "invoice_status",
    label: "Invoice status",
    minWidth: 80,
    align: "left",
    format: (order) => order.invoice_id ?? "",
    orderable: false,
  },
  {
    id: "attempt_count",
    label: "Attempt count",
    minWidth: 50,
    align: "center",
    format: (order) => order.attempt_count.toString(),
    orderable: false,
  },
  {
    id: "last_attempt_at",
    label: "Last attempt",
    minWidth: 100,
    align: "center",
    format: (order) =>
      order.last_attempt_at
        ? format(new Date(order.last_attempt_at), `MMM d yyyy`)
        : "N/A",
    orderable: true,
    orderBy: "last_attempt_at",
  },
  {
    id: "next_attempt_at",
    label: "Next attempt",
    minWidth: 100,
    align: "center",
    format: (order) =>
      order.next_attempt_at
        ? format(new Date(order.next_attempt_at), `MMM d yyyy`)
        : "N/A",
    orderable: true,
    orderBy: "next_attempt_at",
  },
];
